module.exports = __webpack_public_path__ + "images/InMode-3c5dd3.png";